var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8243 2.03006C11.9625 2.9086 12.9316 4.19571 13.6276 5.80541C13.6796 5.92759 13.6796 6.07046 13.6276 6.18682C12.2357 9.40622 9.75764 11.3327 6.99992 11.3327H6.99341C4.2422 11.3327 1.76415 9.40622 0.372276 6.18682C0.320244 6.07046 0.320244 5.92759 0.372276 5.80541C1.76415 2.58537 4.2422 0.666016 6.99341 0.666016H6.99992C8.37878 0.666016 9.6861 1.1444 10.8243 2.03006ZM4.39829 5.99935C4.39829 7.42157 5.56252 8.57874 6.99992 8.57874C8.43081 8.57874 9.59504 7.42157 9.59504 5.99935C9.59504 4.57066 8.43081 3.41349 6.99992 3.41349C5.56252 3.41349 4.39829 4.57066 4.39829 5.99935Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62053 5.99702C8.62053 6.88268 7.89207 7.60672 7.00102 7.60672C6.10346 7.60672 5.375 6.88268 5.375 5.99702C5.375 5.88712 5.38801 5.78433 5.40752 5.6809H5.44004C6.16199 5.6809 6.74736 5.11201 6.77337 4.40025C6.84492 4.38797 6.92297 4.38086 7.00102 4.38086C7.89207 4.38086 8.62053 5.1049 8.62053 5.99702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.bcbe0da0baa3bcd73094ace99ac64356.svg";
export { ForwardRef as ReactComponent };